import Icon from '../components/Icon.vue'

Icon.register({
  'angle-down': {
    width: 320,
    height: 512,
    paths: [
      {
        d: 'M143 352.3l-136-136c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.2 9.4-24.4 9.4-33.8 0z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/angle-down.js
// module id = 603
// module chunks = 0